import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Box,
	Container,
	Typography,
	Divider,
	TextField,
	Autocomplete,
	Chip,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from "@mui/material";

import queryGraphql from "../../helpers/ApiInterface";
import { ExpandMore } from "@mui/icons-material";
import MainDrawer from "../MainDrawer";
import ApplicationRequestsTable from "./ApplicationRequestsTable";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}

let searchOptions: SearchOptions[] = [];
const ApplicationRequestsPage: React.FC = () => {
	const [applications, setApplications] = useState([]);
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [updates, setUpdates] =  useState<any>([]);
	const navigate = useNavigate();
	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);	
	
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        applications {
						id,
                        applicationName,
                        applicationOwner{
                        id,
                        name,
                        email,
                        googleProfilePicture,
                        },
                        actionedAt,
                        reasonForRejection,
                        applicationApprover{
                        id,
                        name,
                        email,
                        googleProfilePicture,
                        },
                        createdAt,
                        status
                        }
                        }
					`);

				let applicationsArr = data.applications.map((e: any) => {
					return {
						...e,

						applicationOwnerAvatar: e?.applicationOwner?.googleProfilePicture,
						applicationOwner: e?.applicationOwner?.name,
						applicationApproverAvatar: e?.applicationApprover?.googleProfilePicture,
						applicationApprover: e?.applicationApprover?.name,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
						actionedAt: new Date(Number(e.actionedAt)).toISOString(),
					};
				});
				setApplications(applicationsArr);
				searchOptions = applicationsArr
					.map((e: any) => {
						return [
							{
								category: "applicationName",
								groupBy: "APPLICATION NAME",
								chipLabel: `Application Name: ${e.applicationName}`,
								dropdownLabel: e.applicationName,
							},

							{
								category: "applicationOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.applicationOwner}`,
								dropdownLabel: e.applicationOwner,
							},
							{
								category: "applicationApprover",
								groupBy: "ACTIONED BY",
								chipLabel: `Actioned By: ${e.applicationApprover}`,
								dropdownLabel: e.applicationApprover,
							},
						];
					})
					.flat();

				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});

				// setUsers(result.data.users);
				// setLoading(false);
			} catch (error) {
				// setError(error.message);
				// setLoading(false);
				console.log(error);
			}
		};

		fetchData();
	}, []);

	const filteredApplications =
		searchQuery.length == 0
			? applications
			: applications.filter(
					(application: any) =>
						(searchQuery.filter((e) => e.category == "applicationName").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.applicationName?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "applicationOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.applicationOwner?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "applicationApprover").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationApprover")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(application.applicationApprover?.toLowerCase())
							: true)
			  );
	const filteredActiveApplications = filteredApplications.filter(
		(application: any) => application.status === "active"
	);
	const filteredPendingApplications = filteredApplications.filter(
		(application: any) => application.status === "pending"
	);
	const filteredRejectedApplications = filteredApplications.filter(
		(application: any) => application.status === "rejected"
	);

	return (
		<Box sx={{ display: "flex" }}>
			<MainDrawer index={"requests-application"} />
			<MiniBot/>
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginY: 1,
								marginLeft: 2,
							}}
						>
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Requests
							</Typography>
							<IconButton
																	  aria-label="Help" 
																	  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
																	  sx={{
																		padding: 0, 
																		border: 'none',  
																		mr:2,
																		'&:hover': {
																		  
																		  backgroundColor: 'action.hover', 
																		},
																		
																	  }}
																	>
																	  <Box
																		component="img"
																		src="/assets/Help.svg" 
																		alt="" 
																		sx={{
																		  width: 40,  
																		  height: 40,
																		  display: 'block', 
																		}}
																	  />
																	</IconButton>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box
							sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mx: 2 }}
						>
							<Box>
								<Typography
									fontFamily="Gilroy-SemiBold"
									fontSize="16px"
								>{`APPLICATIONS (${applications.length})`}</Typography>
								<Typography
									fontFamily="Gilroy-Regular"
									fontSize="14px"
								>{`View all the requests raised by the application owners`}</Typography>
							</Box>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by application name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>
						</Box>
					</Box>
					<Box m={2}>
						<Accordion
							defaultExpanded={filteredPendingApplications.length > 0 ? true : false}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredPendingApplications.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/clock.svg"
										alt="Pending Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Pending Applications ({filteredPendingApplications.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredPendingApplications.length > 0 && (
									<ApplicationRequestsTable applications={filteredPendingApplications} resourceStatuses={updates}/>
								)}
							</AccordionDetails>
						</Accordion>
						<Accordion
						defaultExpanded={true}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredActiveApplications.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/tickcircle.svg"
										alt="Active Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Active Applications ({filteredActiveApplications.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredActiveApplications.length > 0 && (
									<ApplicationRequestsTable applications={filteredActiveApplications} resourceStatuses={updates} />
								)}
							</AccordionDetails>
						</Accordion>

						<Accordion
							elevation={0}
							sx={{
								borderRadius: "8px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredRejectedApplications.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/reject.svg"
										alt="Rejected Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Rejected Applications ({filteredRejectedApplications.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredRejectedApplications.length > 0 && (
									<ApplicationRequestsTable applications={filteredRejectedApplications} resourceStatuses={updates}/>
								)}
							</AccordionDetails>
						</Accordion>
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ApplicationRequestsPage;
